import _functionUncurryThisAccessor from "../internals/function-uncurry-this-accessor";
import _isObject from "../internals/is-object";
import _requireObjectCoercible from "../internals/require-object-coercible";
import _aPossiblePrototype from "../internals/a-possible-prototype";
var exports = {};
/* eslint-disable no-proto -- safe */
var uncurryThisAccessor = _functionUncurryThisAccessor;
var isObject = _isObject;
var requireObjectCoercible = _requireObjectCoercible;
var aPossiblePrototype = _aPossiblePrototype;

// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
exports = Object.setPrototypeOf || ("__proto__" in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;
  try {
    setter = uncurryThisAccessor(Object.prototype, "__proto__", "set");
    setter(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) {/* empty */}
  return function setPrototypeOf(O, proto) {
    requireObjectCoercible(O);
    aPossiblePrototype(proto);
    if (!isObject(O)) return O;
    if (CORRECT_SETTER) setter(O, proto);else O.__proto__ = proto;
    return O;
  };
}() : undefined);
export default exports;